import * as React from 'react';
import { Col } from 'reactstrap';
import PosterPersonTitle from './PosterPersonTitle';
import PosterPersonImage from './PosterPersonImage';
import PosterPersonInformation from './PosterPersonInformation';
import { IPosterPrintPersonProps } from '../PosterPrint';

export const PosterPrintPerson = (props: IPosterPrintPersonProps) => {
  const portrait = props.personInfo && props.personInfo.images && props.personInfo.images && props.personInfo.images.length > 0 ? props.personInfo.images[0] : 'https://s3.us-east-2.amazonaws.com/caseview-children-assets/Images/no_photo_found.jpg'
  return (
    <Col className={`col-${props.colSize} poster-child-container ${props.className || ''}`}>
      <PosterPersonTitle fullName={props.personInfo && props.personInfo.fullName} />
      <PosterPersonImage portrait={portrait} />
      <PosterPersonInformation {...props} />
    </Col>
  )
};
